module.exports = __webpack_public_path__ + "static/media/nicka.8d7b0fec.mp3";